module.exports = __webpack_public_path__ + "img/ZG81_17.d485eac2.jpg";